import * as React from 'react'; 
import { connect } from 'react-redux';
import { FestivalOverviewAppState } from '../classes/redux-states';
import { Dispatch } from 'redux';
import { Series } from '../classes/series';
import { ActionType } from '../redux/actions/actions';
import { ProductionListComponent } from './production-list';

export interface ExternalProps {
    series: Series;
}

interface DispatchToProps {

}

export interface StateToProps {

}

type SeriesProps = ExternalProps & DispatchToProps & StateToProps;

export class SeriesComponent extends React.Component<SeriesProps, null> {
    constructor(props: SeriesProps) {
        super(props);
    }

    
    render() {
        return (
            <div className={"season-overview-list-item" + ` venue-theme-${this.props.series.seriesTheme}`} id={this.props.series.seriesIDTitle}>
                <h3 className="season-overview-list-item-title">{this.props.series.seriesName}</h3>
                <p className="rich-text" dangerouslySetInnerHTML={{ __html: this.props.series.seriesDescription }}></p>
                <ProductionListComponent productionList={this.props.series.productions} />
            </div>
        )
    }
}

function mapStateToProps(state: FestivalOverviewAppState): StateToProps {
    return {

    }
}

function mapDispatchToProps(dispatch: Dispatch<FestivalOverviewAppState>, ownProps: ExternalProps): DispatchToProps {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SeriesComponent)